export default __webpack_public_path__ + "static/media/Cesar_Jimenez.f936def0.png";